/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowTaskActorStatus } from './WorkflowTaskActorStatus';
import {
    WorkflowTaskActorStatusFromJSON,
    WorkflowTaskActorStatusFromJSONTyped,
    WorkflowTaskActorStatusToJSON,
} from './WorkflowTaskActorStatus';

/**
 * 
 * @export
 * @interface TaskActorResponseDto
 */
export interface TaskActorResponseDto {
    /**
     * Workflow task actor id that is used for this operation
     * @type {string}
     * @memberof TaskActorResponseDto
     */
    workflowInstanceAssignedTaskId?: string;
    /**
     * User Id
     * @type {string}
     * @memberof TaskActorResponseDto
     */
    userId?: string;
    /**
     * Name of a user. Usually it is a personalNames + ' ' + familyNames
     * @type {string}
     * @memberof TaskActorResponseDto
     */
    userName?: string;
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof TaskActorResponseDto
     */
    workflowInstanceId?: string;
    /**
     * Task Type for Workflow participants. Set of task types is different for each workflow model
     * @type {string}
     * @memberof TaskActorResponseDto
     */
    taskType?: string;
    /**
     * Localizable name of the item
     * @type {string}
     * @memberof TaskActorResponseDto
     */
    symbolicTextId?: string;
    /**
     * 
     * @type {WorkflowTaskActorStatus}
     * @memberof TaskActorResponseDto
     */
    status?: WorkflowTaskActorStatus;
    /**
     * 
     * @type {string}
     * @memberof TaskActorResponseDto
     * @deprecated
     */
    callbackUrl?: string;
}

/**
 * Check if a given object implements the TaskActorResponseDto interface.
 */
export function instanceOfTaskActorResponseDto(value: object): boolean {
    return true;
}

export function TaskActorResponseDtoFromJSON(json: any): TaskActorResponseDto {
    return TaskActorResponseDtoFromJSONTyped(json, false);
}

export function TaskActorResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskActorResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceAssignedTaskId': json['workflowInstanceAssignedTaskId'] == null ? undefined : json['workflowInstanceAssignedTaskId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'workflowInstanceId': json['workflowInstanceId'] == null ? undefined : json['workflowInstanceId'],
        'taskType': json['taskType'] == null ? undefined : json['taskType'],
        'symbolicTextId': json['symbolicTextId'] == null ? undefined : json['symbolicTextId'],
        'status': json['status'] == null ? undefined : WorkflowTaskActorStatusFromJSON(json['status']),
        'callbackUrl': json['callbackUrl'] == null ? undefined : json['callbackUrl'],
    };
}

export function TaskActorResponseDtoToJSON(value?: TaskActorResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceAssignedTaskId': value['workflowInstanceAssignedTaskId'],
        'userId': value['userId'],
        'userName': value['userName'],
        'workflowInstanceId': value['workflowInstanceId'],
        'taskType': value['taskType'],
        'symbolicTextId': value['symbolicTextId'],
        'status': WorkflowTaskActorStatusToJSON(value['status']),
        'callbackUrl': value['callbackUrl'],
    };
}

